/* eslint-disable import/prefer-default-export */
import * as ReactQuery from "@tanstack/react-query";
// Services
import * as Brm from "services/brm";

export const useGetThreatEventCategories = (projectId, config = {}) => {
  return ReactQuery.useQuery({
    ...config,
    queryKey: ["threatEventCategories", projectId],
    queryFn: () => Brm.threatEventCategoryApi.findThreatEventCategory(projectId),
  });
};
